'use client';

import getConfig from 'next/config';
import { getAuthCookie } from '../getters/auth';
import { useRestQueryRequest } from './use-request';
export default function useCompanyDetails(companyId, sessionId, employeeId, isLoggedIn, companyDetails) {
  var _companyDetailsData$r;
  var _ref = getConfig() || {},
    _ref$publicRuntimeCon = _ref.publicRuntimeConfig,
    publicRuntimeConfig = _ref$publicRuntimeCon === void 0 ? {} : _ref$publicRuntimeCon;
  var idTokenCookie = getAuthCookie();
  var params = {
    'session-id': sessionId,
    'employee-id': employeeId,
    'company-id': companyId,
    Authorization: "Bearer ".concat(idTokenCookie)
  };
  var _useRestQueryRequest = useRestQueryRequest(['CompanyDetails', idTokenCookie], 'GET', "".concat(publicRuntimeConfig.NEXT_PUBLIC_REST_API, "/company/").concat(companyId), params, {
      enabled: isLoggedIn && !!companyId && !companyDetails
    }),
    data = _useRestQueryRequest.data;
  var companyDetailsData = companyDetails !== null && companyDetails !== void 0 ? companyDetails : data;
  if (companyDetailsData !== null && companyDetailsData !== void 0 && (_companyDetailsData$r = companyDetailsData.requestedCompany) !== null && _companyDetailsData$r !== void 0 && _companyDetailsData$r.companyDetails) {
    var _companyDetailsData$r2 = companyDetailsData.requestedCompany.companyDetails,
      companyName = _companyDetailsData$r2.companyName,
      alternateCompanyName = _companyDetailsData$r2.alternateCompanyName;
    if (companyName !== null && companyName !== void 0 && companyName.length && alternateCompanyName !== null && alternateCompanyName !== void 0 && alternateCompanyName.length) {
      companyDetailsData.requestedCompany.companyDetails.companyName = alternateCompanyName;
    }
  }
  return companyDetailsData;
}